import React from 'react';

import { AutocompleteField } from '~/components/core/AutocompleteField/AutocompleteField';
import useAutocomplete from '~/hooks/useAutocomplete';
import type { AutocompleteResponseBaseModelWorkflowOptionWorkflowOption } from '~/server_shared/openapi/data-contracts';

interface WorkflowNameAutocompleteProps {
  organizationId: number;
  value: string; // Display value (workflow name)
  onChange: (workflowId: string, workflowName: string) => void;
  label?: string;
  className?: string;
  disabled?: boolean;
}

export const WorkflowNameAutocomplete: React.FC<WorkflowNameAutocompleteProps> = ({
  organizationId,
  value,
  onChange,
  label = 'Workflow Name',
  className,
  disabled = false,
}) => {
  const { suggestions, isLoading, fetchSuggestions } =
    useAutocomplete<AutocompleteResponseBaseModelWorkflowOptionWorkflowOption>({
      organizationId,
      fetchUrl: `/api/v1/automation/workflow_engine/executions/organizations/${organizationId}/workflow_options/autocomplete`,
      limit: 10,
    });

  const handleChange = (id: string | number, name: string) => {
    onChange(String(id), name);
  };

  return (
    <AutocompleteField<AutocompleteResponseBaseModelWorkflowOptionWorkflowOption>
      id="workflow-name-autocomplete"
      label={label}
      value={value}
      onChange={handleChange}
      options={suggestions}
      loading={isLoading}
      onInputChange={fetchSuggestions}
      className={className}
      disabled={disabled}
    />
  );
};
